import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthServices } from './auth.services';
import * as _ from 'lodash';
import {Observable} from 'rxjs/Observable';
import { CommonServices} from '../../services/src/api';
import {EnvUtils} from '../../utils';

@Injectable()
export class EscalationGuard implements CanActivate {
    checkURL = '/escalation';
    constructor(private router: Router,
                private authService: AuthServices,
                private commonServices: CommonServices) {
    }

    canActivate(): Observable<boolean> | boolean {
        let userRole = global['userRole'];

        if (userRole !== undefined) {
            const rolePrm = _.find(userRole.rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_020', 'rsrcPathVal': this.checkURL});
            const IF_ACCESSIBLE = rolePrm === undefined ? false : true;
            if (!IF_ACCESSIBLE) {
                this.router.navigate(['/']);
            }
            return  Observable.of(IF_ACCESSIBLE);
        } else {
            const access_token = EnvUtils.envCdToAccessToken();
            return this.commonServices.getSessionMap(access_token)
                .map(rsltUserRole => {
                    userRole = rsltUserRole;

                    const rolePrm = _.find(userRole.rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_020', 'rsrcPathVal': this.checkURL});
                    const IF_ACCESSIBLE = rolePrm === undefined ? false : true;

                    if (!IF_ACCESSIBLE) {
                        this.router.navigate(['/']);
                    }
                    return IF_ACCESSIBLE;
                });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/authentications/src/escalation.guard.ts